import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { PHONE_NUMBER } from '../../utils/constants';

const CTABanner = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-white/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-80 h-80 bg-secondary-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-primary-200 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('cta.subtitle')}
        </p>

        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/get-quote"
            className="px-10 py-4 bg-white text-primary-700 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all duration-300 shadow-xl hover:-translate-y-0.5"
          >
            {t('cta.button')}
          </Link>
          <a
            href={`tel:${PHONE_NUMBER}`}
            className="px-10 py-4 border-2 border-white/30 text-white rounded-xl font-semibold text-lg hover:bg-white/10 hover:border-white/60 transition-all duration-300"
          >
            {t('cta.phone')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
